
  const PREFIX = /^\(\d+\+?\) /

  export default {
    mounted() {
      this.observer = new MutationObserver(() => this.markTitle())
      this.observer.observe(document.querySelector("title"), {childList: true, subtree: true, characterData: true})
      this.markTab()
    },

    updated() {
      this.markTab()
    },

    destroyed() {
      this.observer.disconnect()
      document.title = document.title.replace(PREFIX, "")
      if (this.link) this.link.setAttribute("href", this.icon)
    },

    count() {
      return Number(this.el.dataset.unread || 0)
    },

    // The tab is the only thing a tester can see while they are working in the app under
    // test, so the count goes in the title and on the icon rather than only on this button.
    markTab() {
      this.markTitle()
      this.markIcon()
    },

    markTitle() {
      const count = this.count()
      const title = document.title.replace(PREFIX, "")
      const marked = count > 0 ? `(${count}) ${title}` : title
      if (document.title !== marked) document.title = marked
    },

    markIcon() {
      const count = this.count()

      if (!this.link) {
        this.link = document.querySelector("link[rel~='icon']")

        if (!this.link) {
          this.link = document.createElement("link")
          this.link.setAttribute("rel", "icon")
          this.link.setAttribute("href", "/favicon.ico")
          document.head.appendChild(this.link)
        }

        this.icon = this.link.getAttribute("href")
      }

      if (count === 0) {
        this.link.setAttribute("href", this.icon)
        return
      }

      const canvas = document.createElement("canvas")
      canvas.width = canvas.height = 32
      const context = canvas.getContext("2d")

      context.beginPath()
      context.arc(16, 16, 15, 0, 2 * Math.PI)
      context.fillStyle = getComputedStyle(document.documentElement).getPropertyValue("--color-danger-500")
      context.fill()

      context.fillStyle = "#ffffff"
      context.textAlign = "center"
      context.textBaseline = "middle"
      context.font = "600 20px Helvetica, Arial, sans-serif"
      context.fillText(count > 9 ? "9+" : String(count), 16, 17)

      this.link.setAttribute("href", canvas.toDataURL("image/png"))
    }
  }
